import BaseProxy from './BaseProxy';

class Mail extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/mail/templates', parameters);
    }
}

export default Mail;



// WEBPACK FOOTER //
// ./src/api/Mail.js